import {
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAIL,
  CUSTOMER_REINIT_STATE,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  SET_USER_IS_ACTIVE_SUCCESS,
  SET_USER_IS_ACTIVE_FAIL,
  SET_USER_IS_APPROVED_SUCCESS,
  SET_USER_IS_APPROVED_FAIL,
  SET_USER_NEEDS_PASSWORD_RESET_SUCCESS,
  SET_USER_NEEDS_PASSWORD_RESET_FAIL,
  CREATE_NEW_USER_FAIL,
  CREATE_NEW_USER_SUCCESS,
  CREATE_NEW_USER,
  ADD_TAG_SUCCESS_USER,
  ADD_TAG_FAIL_USER,
  UPDATE_TAG_SUCCESS_USER,
  ADD_USER_ROLE_SUCCESS,
  ADD_USER_ROLE_FAIL,
  ADD_USER_ROLE,
  DELETE_USER_ROLE,
  DELETE_USER_ROLE_SUCCESS,
  DELETE_USER_ROLE_FAIL,
  SET_USER_EMAIL_VERIFIED,
  SET_USER_EMAIL_VERIFIED_SUCCESS, SET_USER_EMAIL_VERIFIED_FAIL,
} from "constants/ActionTypes";

const INIT_STATE = {
  users: null,
  loadingUsers: false,
  loadingUsersError: false,
  loadingAddUserRole: {},
  addUserRoleError: {},
  loadingDeleteUserRole: {},
  deleteUserRoleError: {},
  loadingIsUserVerified: {},
  loadingIsUserVerifiedError: {},
  appMisc: {
    didJustCreateNewUser: null,
    didJustCreateNewCustomer: null
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case FETCH_USERS_SUCCESS: {
      // console.log("FETCH_USERS_SUCCESS with payload data:", action.payload)
      return {
        ...state,
        users: action.payload,
        loadingUsers: false,
        loadingUsersError: false
      }
    }

    case FETCH_USERS: {
      return {
        ...state,
        loadingUsers: true,
        loadingUsersError: false
      }
    }

    case FETCH_USERS_FAIL: {
      return {
        ...state,
        loadingUsers: false,
        loadingUsersError: true
      }
    }


    case SET_USER_IS_ACTIVE_SUCCESS: {
      console.log("updating state for SET_USER_IS_ACTIVE_SUCCESS", action.payload);
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload.userId] : {
            ...state.users[action.payload.userId],
            is_active: action.payload.newIsActiveStatus
          }
        }
      }
    }

    case SET_USER_IS_APPROVED_SUCCESS: {
      console.log("updating state for SET_USER_IS_APPROVED_SUCCESS", action.payload);
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload.userId] : {
            ...state.users[action.payload.userId],
            is_approved: action.payload.newIsApprovedStatus
          }
        }
      }
    }

    case SET_USER_NEEDS_PASSWORD_RESET_SUCCESS: {
      console.log("updating state for SET_USER_NEEDS_PASSWORD_RESET_SUCCESS", action.payload);
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload.userId] : {
            ...state.users[action.payload.userId],
            needs_password_reset: action.payload.newNeedsPasswordResetStatus
          }
        }
      }
    }

    case DELETE_USER_SUCCESS:
    {
      return {
        ...state,
        users: {
          ...state.users.filter(user => user.userId !== action.payload.data.userId)
        }
      }
    }

    case DELETE_USER_FAIL:
    case SET_USER_IS_ACTIVE_FAIL:
    case SET_USER_IS_APPROVED_FAIL:
    case SET_USER_NEEDS_PASSWORD_RESET_FAIL:{
      return {
        ...state
      }
    }

    case CREATE_NEW_USER:
      return {
        ...state,
        appMisc: {
          ...state.appMisc,
          didJustCreateNewUser: null
        },
      }

    case CREATE_NEW_USER_FAIL:
      return {
        ...state,
        appMisc: {
          ...state.appMisc,
          didJustCreateNewUser: false
        },
      }

    case CREATE_NEW_USER_SUCCESS:
      return {
        ...state,
        appMisc: {
          ...state.appMisc,
          didJustCreateNewUser: true
        },
      }

    case CUSTOMER_REINIT_STATE: {
      return {
        ...INIT_STATE,
      }
    }

      /***********************************
       * ADD_TAG FOR USERS
       ***********************************/

    case ADD_TAG_SUCCESS_USER: {

      const userId = action.payload.userId
      const affectedElementId = action.payload.affectedElementId
      const newTagData = action.payload.inboundData

      console.log("Adding a new successful Tag to Local State tree.",userId, affectedElementId, newTagData);

      // console.log("ADD_TAG_SUCCESS reducer about to put new business shares into the state. Here are the shares", newTagsData, "for these entities", entities, "for this entityId", entityId);
      console.log("state", state, state.users, state.users.userId, state.users.userId.tags )

      const newUserTags = state
      && state.users
      && state.users[userId]
      && state.users[userId].tags
          ? {
            ...state.users[userId].tags,
            [newTagData.id] : newTagData
          }
          : null;

      console.log("Calculated new userTags by adding", newTagData, "Final tag sate:", newUserTags);

      const newUsers = {
          ...state.users,
        [userId] :{
            ...state.users[userId],
          tags: newUserTags ? newUserTags : state.users[userId].tags
          }
        }



      return {
        ...state,
        users: newUsers
      }
    }

    case ADD_TAG_FAIL_USER: {
      // const affectedElementId = action.payload.affectedElementId
      return {
        ...state,

      }
    }

      /***********************************
       * UPDATE_TAG FOR USERS
       ***********************************/

    case UPDATE_TAG_SUCCESS_USER: {
      const userId = action.payload.userId
      const affectedElementId = action.payload.affectedElementId
      const newTagData = action.payload.inboundData
      const tagId = action.payload.tagId

      console.log("updating a user tag to local state tree",userId, affectedElementId, newTagData);

      const newUsers = {
        ...state.users,
        [userId]: {
          ...state.users[userId],
          tags: {
            ...state.users[userId].tags,
            [tagId] : newTagData
          }
        }
      }

      return{
        ...state,
        users: newUsers
      }
    }
      /***********************************
       * ADD USER ROLE
       ***********************************/
    case ADD_USER_ROLE: {
      const userId = action.payload.userId;

      return {
        ...state,

        loadingAddUserRole: {
          ...state.loadingAddUserRole,
          [userId] : true,
        },

        addUserRoleError: {
          ...state.addUserRoleError,
          [userId]: false,
        }
      }
    }

    case ADD_USER_ROLE_SUCCESS: {

      const userId = action.payload.userId;
      // const roleId = action.payload.roleId;

      const newRoleObject = action.payload.inboundData;

      // console.log("ADD_USER_ROLE about to add role,", roleId, "to user", userId, "payload looks like", action.payload);

      const existingRolesArray = state.users[userId].roles ? state.users[userId].roles : [];
      existingRolesArray.push(newRoleObject);

      // console.log("object being returned in inboudn data", newRoleObject, "exiswwtingROlesArray", existingRolesArray, )

      return {
        ...state,
        users: {
          ...state.users,
          [userId]: {
            ...state.users[userId],
            roles: existingRolesArray,
          }
        },

        loadingAddUserRole: {
          ...state.loadingAddUserRole,
          [userId] : false,
        },

        addUserRoleError: {
          ...state.addUserRoleError,
          [userId]: false,
        }
      }
    }

    case ADD_USER_ROLE_FAIL: {
      const userId = action.payload.userId;

      return {
        ...state,

        loadingAddUserRole: {
          ...state.loadingAddUserRole,
          [userId] : false,
        },

        addUserRoleError: {
          ...state.addUserRoleError,
          [userId]: true,
        }
      }
    }


      /***********************************
       * DELETE USER ROLE
       ***********************************/

    case DELETE_USER_ROLE: {
      const userId = action.payload.userId;

      return {
        ...state,

        loadingDeleteUserRole: {
          ...state.loadingDeleteUserRole,
          [userId] : true,
        },

        deleteUserRoleError: {
          ...state.deleteUserRoleError,
          [userId]: false,
        }
      }
    }

    case DELETE_USER_ROLE_SUCCESS: {

      const userId = action.payload.userId;
      const roleId = action.payload.roleId;

      // const newRoleObject = action.payload.inboundData;

      // console.log("DELETE_USER_ROLE about to remove role,", roleId, "to user", userId, "payload look slike", action.payload);

      const existingRolesArray = state.users[userId].roles ? state.users[userId].roles : [];
      const newRolesArray = existingRolesArray.filter((role)=>role.role.id !== roleId);

      // console.log("object being returned in inboudn data", newRoleObject, "exiswwtingROlesArray", existingRolesArray)


      return {
        ...state,
        users: {
          ...state.users,
          [userId]: {
            ...state.users[userId],
            roles: newRolesArray,
          }
        },

        loadingDeleteUserRole: {
          ...state.loadingDeleteUserRole,
          [userId] : false,
        },

        deleteUserRoleError: {
          ...state.deleteUserRoleError,
          [userId]: false,
        }
      }
    }

    case DELETE_USER_ROLE_FAIL: {
      const userId = action.payload.userId;

      return {
        ...state,

        loadingDeleteUserRole: {
          ...state.loadingDeleteUserRole,
          [userId] : false,
        },

        deleteUserRoleError: {
          ...state.deleteUserRoleError,
          [userId]: true,
        }
      }
    }

      /***********************************
       * UPDATE IS USER EMAIL VERIFIED
       ***********************************/

    case SET_USER_EMAIL_VERIFIED: {
    const userId = action.payload && action.payload.userId;

      return  {
      ...state,
        loadingIsUserVerified: {
        ...state.loadingIsUserVerified,
          [userId]: true,
        },
        loadingIsUserVerifiedError: {
        ...state.loadingIsUserVerifiedError,
          [userId]: false,
      },
      }
    }

    case SET_USER_EMAIL_VERIFIED_SUCCESS: {
      const userId = action.payload && action.payload.userId;
      const newIsVerifiedStatus = action.payload.newIsVerifiedStatus;


      return{
        ...state,
        loadingIsUserVerified: {
          ...state.loadingIsUserVerified,
          [userId]: false,
        },
        loadingIsUserVerifiedError: {
          ...state.loadingIsUserVerifiedError,
          [userId]: false,
        },
        users: {
          ...state.users,
          [userId]: {
            ...state.users[userId],
            is_activated: newIsVerifiedStatus
          }
        }
      }
    }

    case SET_USER_EMAIL_VERIFIED_FAIL:{
      const userId = action.payload && action.payload.userId;
      const newIsVerifiedStatus = action.payload.newIsVerifiedStatus;


      return{
        ...state,
        loadingIsUserVerified: {
          ...state.loadingIsUserVerified,
          [userId]: false,
        },
        loadingIsUserVerifiedError: {
          ...state.loadingIsUserVerifiedError,
          [userId]: true,
        },
      }
    }

    default:
      return state;


  }
}



